var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://sk.ru/","target":"_blank"}},[_c('span',{staticClass:"skolkovo-desktop"})])}]

export { render, staticRenderFns }